import { Component, OnInit } from '@angular/core';
import { TextService } from '../../../shared/services/text.service';
import { SessionService } from '../../../shared/services/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { UyeIsyerineDonus } from "../../../model/netmera-events/uye-isyerine-donus";
import { ValidationService } from 'src/app/shared/services/validation.service';

@Component({
  selector: 'pa-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {
  deadline = Date.now() + 1000 * 20;
  defaultUrl = 'https://paycell.com.tr/';
  redirectToSiteName: string;

  textService: TextService;
  trackingId: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private route: ActivatedRoute, private sessionService: SessionService, textService: TextService,
              private netmeraService: NetmeraService, private uyeIsyerineDonus: UyeIsyerineDonus,private validationService:ValidationService) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
    this.sessionService.getSessionInfo(this.trackingId).subscribe(user => {
        if (user === null || user.returnUrl === 'undefined' || user.returnUrl === null) {
          this.redirectToSiteName = this.defaultUrl;
        } else {
          this.sdkInitTexts = user.sdkInitTexts;
          const pattern = new RegExp('^(https?|http)://');
          if (pattern.test(user.returnUrl)) {
            this.redirectToSiteName = user.returnUrl;
          } else {
            this.redirectToSiteName = this.defaultUrl;
          }
        }
      },
      error => {
        this.sdkInitTexts = new Array<SdkInitText>();
        this.redirectToSiteName = this.defaultUrl;
      }
    );
    //Cookie kullanıcı bilgilerini temizlemek
    this.validationService.logout().subscribe((res)=>{
    },(err)=>{
      console.log(err);
    })
  }

  stop(detay: string) {
    this.pushEvent(detay);
    setTimeout(()=>{
      window.location.href = this.redirectToSiteName ? this.redirectToSiteName : this.defaultUrl;
    }, 2000);

  }

  pushEvent(detay: string) {
    this.netmeraService.pushEvent(this.uyeIsyerineDonus.setEventObject(detay, this.redirectToSiteName));
  }

}
